module.exports = __webpack_public_path__ + "static/media/SmartDash_copy.7b70a25f.png";